import { createFileRoute } from "@tanstack/react-router";

import { PrivacyPage } from "@/features/legal/privacy-page";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});
